/**
 * 管理台 API 根地址（与 app.tsx request.baseURL 一致）。
 * 测试：build:test → REACT_APP_API_BASE_URL 或 tadmin.* → tapi.*
 * 正式：admin.* → api.*
 */
export function resolveAdminApiBaseUrl(): string {
  const envBase = (process.env.REACT_APP_API_BASE_URL as string | undefined)?.trim();
  if (envBase) {
    return envBase.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    if (hostname.startsWith('tadmin.')) {
      return `${protocol}//${hostname.replace(/^tadmin\./, 'tapi.')}/admin`;
    }
    if (hostname.startsWith('admin.')) {
      return `${protocol}//${hostname.replace(/^admin\./, 'api.')}/admin`;
    }
  }
  return '/admin';
}
